// Michigan Tech's undergraduate majors (#2652, round 2). Read on 2026-10-01
// from the official 2026 Undergraduate Catalog's Bachelor's Degrees page
// (mtu.edu/catalog/degrees/bachelors), which lists every degree program by
// college with its degree (BS or BA, the catalog's own abbreviations).
// Concentrations ("Computer Science (BS) - Game Development") are folded
// into their major, and the two Medical Laboratory Science tracks (3+1,
// 4+1) into one line. Left out: the associate degrees (Engineering AS,
// General Studies AS), the "Audits" lists (degree audit codes), minors,
// certificates and graduate programs.
const majors = {
    "slug": "michigan-technological-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree in Michigan Tech's official 2026 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Associate degrees, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Business",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Computing",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Applied Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geospatial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Forest Resources and Environmental Science",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Applied Ecology and Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Science and Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Forestry",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources Management",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Bioproducts",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife Ecology and Conservation",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Sciences and Arts",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Audio Production and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication, Culture, and Media",
                    "degree": "BA"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BS"
                },
                {
                    "name": "Computational Chemistry and Chemical Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Human Biology",
                    "degree": "BS"
                },
                {
                    "name": "Human Factors",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Policy and Community Development",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Scientific and Technical Communication",
                    "degree": "BA"
                },
                {
                    "name": "Scientific and Technical Communication",
                    "degree": "BS"
                },
                {
                    "name": "Social Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sound Design",
                    "degree": "BA"
                },
                {
                    "name": "Sports and Fitness Management",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability Science and Society",
                    "degree": "BS"
                },
                {
                    "name": "Theatre and Entertainment Technology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "Michigan Tech 2026 Undergraduate Catalog, Bachelor's Degrees",
                "url": "https://www.mtu.edu/catalog/degrees/bachelors/"
            },
            "majors": [
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Ecological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechatronics",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
